module.exports = __webpack_public_path__ + "img/thesalon.ab2c3673.png";